export const NAME_SPACE = 'Commons/Map/';
export const ROOT_STATE_KEY = 'map';
